import React from "react";
import {
  TimelineContent,
  TimelineMetaList,
  TimelineMetaRow,
  TimelineNewBadge,
  TimelineTagList,
  TimelineTagPill,
  TimelineTitle,
  TimelineTitleRow,
} from "../TimelineLayout";

const UnderInvestigation = ({milestone}) => (
  <TimelineContent>
    <TimelineTitleRow>
      <TimelineTitle>{milestone.milestone}</TimelineTitle>
      {milestone.notify && <TimelineNewBadge>new</TimelineNewBadge>}
    </TimelineTitleRow>
    <TimelineMetaList>
      <TimelineMetaRow>
        <span className="timeline-meta-label">initiated by:</span>
        <span className="timeline-meta-value">{milestone.contributor}</span>
      </TimelineMetaRow>
      <TimelineMetaRow>
        <span className="timeline-meta-label">date:</span>
        <span className="timeline-meta-value">{milestone.date}</span>
      </TimelineMetaRow>
      <TimelineMetaRow>
        <span className="timeline-meta-label">{milestone.details.length === 1 ? `assignee:` : `assignees:`}</span>
        <TimelineTagList>
          {milestone.details.map((assignee) => (
            <TimelineTagPill key={assignee}>{assignee}</TimelineTagPill>
          ))}
        </TimelineTagList>
      </TimelineMetaRow>
    </TimelineMetaList>
  </TimelineContent>
)

export default UnderInvestigation
